import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    id: String,
    thumb: String,
    autoplay: Boolean
  }

  connect() {
    // Ensure the container is positioned so absolute children are relative to it
    this.element.style.position = "relative"
    this.element.innerHTML = this.thumbnailHtml()

    if (this.autoplayValue) {
      this.element.scrollIntoView({ behavior: "smooth", block: "center" })
      this.play()
    }
  }

  play() {
    const iframe = document.createElement("iframe")
    const embedUrl = `https://www.youtube.com/embed/${this.idValue}?autoplay=1&rel=0`
    iframe.setAttribute("src", embedUrl)
    iframe.setAttribute("frameborder", "0")
    iframe.setAttribute("allowfullscreen", "1")
    iframe.setAttribute("allow", "autoplay")
    
    // Clear the container and append iframe, preserving the container
    this.element.innerHTML = ""
    this.element.appendChild(iframe)
  }

  thumbnailHtml() {
    let imgSrc = `https://img.youtube.com/vi/${this.idValue}/mqdefault.jpg`
    if (this.thumbValue) {
      imgSrc = this.thumbValue
    }
    return `<img src="${imgSrc}" alt="youtube video"> <div class="play-button"></div>`
  }
}
